import template from './sw-cms-el-preview-buy-box.html.twig';
import './sw-cms-el-preview-buy-box.scss';


/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
